import '../../App.scss'
import React, { useState, useEffect } from 'react'
import Highlight from './Highlight'
import data from '../../data/featured'

export default function Featured() {
    return (
      <div className="">
        {data.content.map((info,index)=>(
          <div>
            <Highlight 
            content={info} />
            </div>
        ))}
          </div>

    );
    }
  